import { Box, Typography } from '@mui/material';
import { statusColor } from './searchFormat';

export interface StatusCellProps {
    status: string;
    suffix?: string | null;
    strong?: boolean;
}

export function StatusCell({ status, suffix, strong = false }: StatusCellProps) {
    const label = status.charAt(0).toUpperCase() + status.slice(1);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.75,
                minWidth: 0,
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    flexShrink: 0,
                    bgcolor: statusColor(status),
                }}
            />
            <Typography
                sx={{
                    fontSize: strong ? '11px' : '10px',
                    fontWeight: strong ? 600 : 500,
                    color: strong ? 'text.primary' : 'text.secondary',
                    whiteSpace: 'nowrap',
                    lineHeight: 1.2,
                    flexShrink: 0,
                }}
            >
                {label}
            </Typography>
            {suffix && (
                <Typography
                    sx={{
                        fontSize: '10px',
                        color: 'text.disabled',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        minWidth: 0,
                    }}
                >
                    · {suffix}
                </Typography>
            )}
        </Box>
    );
}